import React from "react";

const SecondaryImagesContainer = ({ image1Location, image2Location, image1AltText, image2AltText }) => {
  if (!image1Location && !image2Location) return null;

  return (
    <div className='secondaryImagesContainer'>
      { image1Location &&
        <img
          src={`${image1Location}`}
          alt={image1AltText}
          className='secondaryImage'
        />
      }

      { image2Location &&
        <img
          src={`${image2Location}`}
          alt={image2AltText}
          className='secondaryImage'
        />
      }

      <style jsx>{`
        .secondaryImagesContainer {
          display: flex;
          justify-content: space-between;
          overflow: hidden;
          margin: 2em 0;
          width: 100%;
          max-width: 1000px;
          max-height: 400px;
          flex-shrink: 0;
        }
        
        .secondaryImage {
          width: 49.5%;
          object-fit: cover;
          object-position: 50% 50%;
          border-radius: 5px;
        }
        
        @media(max-width: 900px) {
          .secondaryImagesContainer {
            max-height: 300px;
          }
        }
        
        @media(max-width: 450px) {
          .secondaryImagesContainer {
            max-height: 200px;
          }
        }
      `}</style>
    </div>
  );
}

export default SecondaryImagesContainer;
